module.exports = __webpack_public_path__ + "img/JRDhGAnjC81629106363407.ab4383d7.jpg";